const pointToPosition = ({ x, y }) => ({ left: x, top: y })
export default pointToPosition
